import { theme } from '@frameio/vapor';

/**
 * Enforces consistent rules for `color-scheme` within
 * the scope of appcues. This is necessary for ensuring
 * a consistent appearance of Appcues tooltips across
 * browsers.
 *
 * It's also required that the `html` and `body`
 * elements within the Appcues context have this rule
 * applied as well. These are applied within the Appcues
 * theme.
 *
 * See https://frame-io.atlassian.net/browse/V4BG-2393 for
 * additional background and information.
 */
const colorSchemeRule = `
  iframe.appcues-tooltip-container {
    color-scheme: dark light !important;
  }
`;

/**
 * Applies appropriate style-rules for Appcues slideouts.
 * For some reason, this element is rendered in a different
 * context only accessible to the client stylesheet and not
 * the Appcues theme.
 */
const slideoutContainerStyle = `
  appcues-container.appcues--theme-1e180164-36b2-4f96-a7c5-304154802541 {
    border-radius: 8px;
    border: 2px solid ${theme.colors.brand.dark} !important;
    box-shadow: ${theme.shadows['32dp']};
  }

  appcues-container:not(.appcues-fullscreen):not(.fullscreen)[data-pattern-type=shorty][data-position^=bottom] {
    bottom: 32px;
  }

  appcues-container:not(.appcues-fullscreen):not(.fullscreen)[data-pattern-type=shorty][data-position=bottomRight] {
    right: 32px;
  }
`;

const styleRules = [colorSchemeRule, slideoutContainerStyle].join('\n');

export function AppcuesAnchor() {
  return (
    <>
      {/* eslint-disable-next-line react/no-danger */}
      <style dangerouslySetInnerHTML={{ __html: styleRules }} />
      <div
        id="appcues-anchor"
        style={{
          position: 'absolute',
          width: 1,
          height: 1,
          left: 'calc(100% - 40px)',
          bottom: 0,
          pointerEvents: 'none',
        }}
      />
    </>
  );
}
